import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Item from './Item';
import { requestDataIfNeeded } from '../../user/duck';
import * as API from '../../core/api';

class List extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      actionTakenFor: [],
    };
  }

  handleAction = async (id, action = 'NO_CHANGE') => {
    const { userActiveProjects, requestUserDataIfNeeded } = this.props;
    const { actionTakenFor } = this.state;

    const nextState = [...actionTakenFor, id];
    this.setState({
      actionTakenFor: nextState,
    });

    // In case there is a change, immediately mark this project as inactive.
    if (action === 'CHANGE') {
      await API.post(`users/me/projects/${id}`, {
        status: 'INACTIVE',
      });
    }

    const actionIsTakenForAllProjects =
      nextState.length === userActiveProjects.length;
    if (actionIsTakenForAllProjects) {
      API.post('users/me/confirm-up-to-date')
        // Refresh user.
        .then(requestUserDataIfNeeded);
    }
  };

  renderItems = () => {
    const { userActiveProjects } = this.props;
    const { actionTakenFor } = this.state;

    return userActiveProjects
      .filter(({ project }) => !actionTakenFor.includes(project._id))
      .map(({ project }) => (
        <Item
          key={project._id}
          project={project}
          onAction={this.handleAction}
        />
      ));
  };

  render() {
    const { t } = this.props;

    return (
      <div className="u-margin-bottom-huge">
        <h3>{t('manageUpdates.confirmTabTitle')}</h3>
        <div className="c-box c-box-primary u-margin-bottom">
          {this.renderItems()}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = { requestUserDataIfNeeded: requestDataIfNeeded };

export default connect(
  null,
  mapDispatchToProps
)(translate()(List));



// WEBPACK FOOTER //
// ./src/updates/user-confirm/List.js